import { isNil } from 'lodash';

interface FormatOptions {
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
  minimumIntegerDigits?: number;
}

export const convertToPercentage = (value: string | number | Date | undefined) => {
  if (!isNil(value)) return `${value}%`;
  return undefined;
};

export const formatCurrency = (value: number | undefined, options: FormatOptions = {}) => {
  if (value !== undefined) {
    const formatted = new Intl.NumberFormat('en-ZA', {
      minimumFractionDigits: options.minimumFractionDigits ?? 2,
      maximumFractionDigits: options.maximumFractionDigits ?? 2
    }).format(value);
    return `R ${formatted.replace(/,/g, '.').replace(/[\u202F\u00A0]/g, ' ')}`;
  }
};

export const formatNumber = (value: number | undefined, options: FormatOptions = {}) => {
  if (value !== undefined) {
    const formatted = new Intl.NumberFormat('en-ZA', {
      minimumIntegerDigits: options.minimumIntegerDigits ?? 1
    }).format(value);
    return formatted.replace(/,/g, '.').replace(/[\u202F\u00A0]/g, ' ');
  }
};
